module.exports = "https://static.wmbcdn.com/uniweb/images/4f04f4a967aedc99c5eda7bf13addce9.jpg";